import { EntityRepository, Repository } from "typeorm";
import { MetalDetectionEntity } from "./metal-detection.entity";

@EntityRepository(MetalDetectionEntity)
export class MetalDetectionRepository extends Repository<MetalDetectionEntity> {

}